export default function Hero() {
  const handleScrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-[520px] md:min-h-[620px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-900 via-background-800 to-background-950"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-transparent"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
              <i className="ri-movie-2-line text-accent-400 text-sm"></i>
              <span className="text-xs font-medium text-accent-300 whitespace-nowrap">深夜剧场 · 秒播不卡</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              夜猫电影院
              <br />
              <span className="text-primary-400">高清电影免费在线观看</span>
            </h1>

            <p className="mt-4 text-lg md:text-xl text-primary-300 font-heading italic">
              熬夜追剧不缓冲，免费影院一网打尽
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
              夜猫电影院汇聚海量高清电影与免费电视剧资源，覆盖最新院线大片、经典老片、热门剧集与综艺动漫。每日实时更新片源，高清画质秒播不卡顿，无需注册即可流畅观影。无论深夜独赏还是朋友聚会，这里都是您最忠实的免费影院伙伴，让每一帧画面都值得熬夜追看。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">10万+</div>
                <div className="text-xs text-foreground-400 mt-1">高清片源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">每日更新</div>
                <div className="text-xs text-foreground-400 mt-1">实时同步</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">秒播不卡</div>
                <div className="text-xs text-foreground-400 mt-1">高清流畅</div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleScrollTo('#index'); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-200 cursor-pointer no-underline whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); handleScrollTo('#cards'); }}
                className="inline-flex items-center gap-2 px-8 py-3 border border-background-300/40 text-background-50 hover:bg-background-50/10 font-semibold rounded-full transition-all duration-200 cursor-pointer no-underline whitespace-nowrap text-sm"
              >
                <i className="ri-grid-line text-lg"></i>
                浏览分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] shadow-2xl shadow-black/30">
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent z-10"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20atmospheric%20cinema%20interior%20with%20golden%20ambient%20lighting%2C%20plush%20red%20velvet%20seats%2C%20subtle%20spotlight%20effects%2C%20cinematic%20wide%20composition%2C%20rich%20texture%20details%2C%20editorial%20photography%20style%20with%20soft%20focus%20edges%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20elegant%20classic%20movie%20theater%20aesthetic%2C%20high%20contrast%20dramatic%20lighting%2C%20no%20people%20empty%20theater%20seats&width=700&height=900&seq=hero-cinema-2026&orientation=portrait"
                alt="夜猫电影院 - 高清电影免费在线观看不卡顿"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.classList.add('hidden');
                  }
                }}
              />
              <div className="absolute bottom-4 left-4 right-4 z-20">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-background-50/70">正在热播</div>
                    <div className="text-sm font-semibold text-background-50">午夜影院 · 精选好片</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}